import React from 'react';
import AutocompleteEntry from 'Components/search/subcomponents/autocompleteEntry';

const Autocomplete = ({
                          itemsProducts,
                          itemsPages,
                          clickAction,
                          submitAction,
                          query,
                          inputValue,
                          insideHeader,
                      }) => {
    const handleClick = () => {
        let urlParams = document.location.search;
        if (urlParams.indexOf('?') > -1) {
            if (urlParams.indexOf('q=') > -1) {
                urlParams = urlParams.replace(/q=([^&#]*)/, `q=${query}`);
            } else {
                urlParams = `${urlParams}&q=${query}`;
            }
        } else {
            urlParams = `?q=${query}`;
        }
        document.location.href = props.dataset.searchResultPage + urlParams;
    };

    return (
        <ul role={"listbox"} aria-roledescription={'Vorgeschlagene Suchbegriffe'} className={'cmp-search__autocomplete-box'}>
            {itemsProducts && itemsProducts.length > 0 && <li tabIndex={"-1"} className={'shop'}>Shop</li>}
            {itemsProducts && itemsProducts.length > 0
                && itemsProducts.map((item, index) => <AutocompleteEntry
                    product={true}
                    key={index}
                    entry={item}
                    query={query}
                    inputValue={inputValue}
                    lastEntry={index === itemsProducts.length - 1}
                    clickAction={clickAction}
                    submitAction={submitAction}/>)
            }
            {itemsPages.length > 0
                && itemsPages.map((item, index) => <AutocompleteEntry
                    product={false}
                    key={index}
                    entry={item}
                    query={query}
                    inputValue={inputValue}
                    clickAction={clickAction}
                    submitAction={submitAction}/>)
            }
            {insideHeader
                && <button aria-label={'Alle Ergebnisse anzeigen'} className={'cmp-button__btn magat-btn magat-btn--primary mt-xs'} onClick={handleClick}>Alle Ergebnisse
                    anzeigen</button>}
        </ul>
    );
};

export default Autocomplete;
